import { apiClient } from '@indipia/shared'
import type { ApiResponse } from '@indipia/shared-types'
import type { ShareLink } from '@indipia/shared-features'

// 고객 고정 링크 조회 — GET /schedule/sites/{siteId}/customer-share-link (현장 기준, 스케줄 없는 현장도 호출 가능).
export async function fetchCustomerShareLink(siteId: number): Promise<ShareLink> {
  const res = await apiClient.get<ApiResponse<{ url: string; expiresNotice: string }>>(
    `/schedule/sites/${siteId}/customer-share-link`,
  )
  const { url, expiresNotice } = res.data.data
  return { url, expiresNotice }
}
